import { Box, Image } from "@chakra-ui/react";
import imgContent01 from "../../../assets/images/content/bg/content-social-01.png";
import imgContent02 from "../../../assets/images/content/bg/content-social-02.png";
import tContent01 from "../../../assets/images/content/bg/content-tablet-social-01.png";
import tContent02 from "../../../assets/images/content/bg/content-tablet-social-02.png";
import mContent01 from "../../../assets/images/content/bg/content-mobile-social-01.png";
import mContent02 from "../../../assets/images/content/bg/content-mobile-social-02.png";

import { useContext } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";


const Social = () => {
  const screen = useContext(ScreenContext).style;
  const contents = [
    {
      pc: imgContent01,
      mobile: mContent01,
      tablet: tContent01,
    },
    {
      pc: imgContent02,
      mobile: mContent02,
      tablet: tContent02,
    }
];

  return (
    <Box w={"100%"}>
      <Image 
        src={contents[0][screen]} 
        w={"100%"} 
        alt="" 
      />
      <Image 
        src={contents[1][screen]} 
        w={"100%"} 
        alt="" 
      />
    </Box>
  );
};

export default Social;